var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgUnlike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 23.2512L12.473 22.8997C9.96635 21.2256 6.79466 19.3336 4.44564 16.5528C1.97005 13.6231 0.782359 10.6143 0.812827 7.35356C0.849741 3.71255 3.76947 0.751221 7.32142 0.751221C10.1404 0.751221 12.0148 2.39185 13.0003 3.57603C13.9859 2.39185 15.8603 0.751221 18.6792 0.751221C22.2312 0.751221 25.1509 3.71255 25.1878 7.35181C25.2206 10.6143 24.033 13.6213 21.555 16.551C19.206 19.3336 16.0343 21.2256 13.5277 22.8997L13.0003 23.2512Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgUnlike);
export default __webpack_public_path__ + "static/media/img-unlike.0ccaae9a4a40b7b34f912c11f26e4c3a.svg";
export { ForwardRef as ReactComponent };